<template>
  <v-layout fill-height class="app-container">
    <v-layout
      pa-0
      class="shrink"
      style="max-height: 100vh; min-height: 100vh!important"
    >
      <ChatList />
    </v-layout>
    <v-divider vertical></v-divider>
    <v-layout
      class="grow"
      :class="`${this.$vuetify.theme.dark ? 'conversation-dark' : 'conversation-light'}`"
    >
      <v-layout class="flex-column events-container">
        <ChatToolbar class="shrink"
          @show-sessions-from-other-services="showSessionsFromOtherServices = !showSessionsFromOtherServices"
        />

        <ChatEvents
          v-if="currentConversation.session.id && !reloadingChatList"
          class="events-container"
          ref="chatEvents"
          :key="currentConversation.session.id"
        />
        <v-layout
          v-else-if="reloadingChatList"
          class="events-container"
          justify-center
          align-center
        >
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
          ></v-progress-circular>
        </v-layout>
        <!-- <v-layout shrink v-if="currentConversation.session.customer.suspect"> -->
        <v-card
          class="card-alert ignore-vue-based"
          max-height="100%"
          fill-width
          v-if="currentConversation.session.customer.suspect"
        >
          <v-card-title class="justify-center white--text">
            <h1>Atenção!</h1>
          </v-card-title>
          <v-card-text
            mx-10
            style="font-size: 18px; word-break: break-word"
            class="text-center white--text"
          >
            <p style="font-size: 18px; word-break: break-word">
              Este número de telefone possui mais de um contato registrado.
              Verifique a identidade da pessoa e em seguida edite a conversa.
              <br />
              Caso seja a pessoa correta na conversa, entre no menu de editar a
              conversa e clique em salvar sem alterar nenhuma informação.
            </p>
          </v-card-text>
        </v-card>

        <ChatAnswerBar class="" v-if="currentConversation.session.id && !reloadingChatList" />
      </v-layout>

      <v-card
        v-if="showSessionsFromOtherServices"
        outlined
        width="360"
      >
        <v-toolbar
          flat
        >
          <v-icon class="mr-2">forum</v-icon>

          <v-toolbar-title
            v-if="sessionsFromOtherServices.length"
          >
            {{ sessionsFromOtherServices.length }}
            {{ sessionsFromOtherServices.length > 1 ? 'conversas' : 'conversa' }}
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="showSessionsFromOtherServices = false"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </template>
            <span>Fechar</span>
          </v-tooltip>
        </v-toolbar>

        <v-divider></v-divider>

        <v-skeleton-loader
          v-if="loadingSessionsFromOtherServices"
          type="list-item-avatar-two-line"
        ></v-skeleton-loader>

        <v-card-text
            v-else-if="sessionsFromOtherServices.length === 0"
            class="text-center text-h6 text--secondary"
         >
            Nenhuma conversa encontrada em outros canais
         </v-card-text>

        <v-list
          v-else
          two-line
          class="pa-0"
        >
          <template
            v-for="(session, index) in sessionsFromOtherServices"
          >
            <v-list-item
              :key="session.id"
              :to="`/customerService2/${session.service.id}/conversation/${session.id}`"
              target="_blank"
            >
              <v-tooltip
                bottom
              >
                <template
                  v-slot:activator="{ on }"
                >
                  <v-list-item-avatar
                    v-on="on"
                  >
                    <v-img
                      v-if="session.user"
                      :src="session.user.profile_photo_url || '/img/default.png'"
                    ></v-img>
                    <v-icon v-else>chat</v-icon>
                  </v-list-item-avatar>
                </template>
                <span>{{ session.user?.name || 'Sem atendente' }}</span>
              </v-tooltip>

              <v-list-item-content>
                <v-list-item-title>
                  {{ session.service.name }}
                </v-list-item-title>
                <v-list-item-subtitle
                  v-if="session.status != 'AUTO'"
                >
                  {{ session.status | conversationStatus }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-list-item-action-text>
                  <v-tooltip
                    bottom
                  >
                    <template
                      v-slot:activator="{ on }"
                    >
                      <span
                        v-on="on"
                      >
                        {{ session.created_at | moment('from') }}
                      </span>
                    </template>
                    <span>{{ session.updated_at | moment("D/MM/YYYY HH:mm:ss") }}</span>
                  </v-tooltip>
                </v-list-item-action-text>
              </v-list-item-action>
            </v-list-item>

            <v-divider
              v-if="index < sessionsFromOtherServices.length - 1"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
      </v-card>

      <v-card
        v-if="showSummary"
        outlined
        width="360"
      >
        <v-toolbar
          flat
        >
          <v-icon class="mr-2">summarize</v-icon>

          <v-spacer></v-spacer>

          <v-btn
            @click="summarize"
            :disabled="summarizing"
            color="primary"
            outlined
          >
            {{ summarizing ? 'Resumindo...' : 'Resumir' }}
          </v-btn>
        </v-toolbar>

        <div class="d-flex align-center">
          <v-combobox
            v-model="summarizer.options.type"
            :disabled="summarizing"
            :items="['headline', 'key-points', 'teaser', 'tldr']"
            class="pa-4"
            hide-details
            label="Tipo"
            style="max-width: 150px;"
          ></v-combobox>

          <a href="https://developer.mozilla.org/en-US/docs/Web/API/Summarizer/type#value" target="_blank">
            <v-icon>help</v-icon>
          </a>

          <v-combobox
            v-model="summarizer.options.length"
            :disabled="summarizing"
            :items="['short', 'medium', 'long']"
            class="pa-4"
            hide-details
            label="Comprimento"
            style="max-width: 150px;"
          ></v-combobox>

          <a href="https://developer.mozilla.org/en-US/docs/Web/API/Summarizer/length#value" target="_blank">
            <v-icon>help</v-icon>
          </a>
        </div>

        <v-card-text>
          <v-progress-linear
            v-if="summarizer.availability === 'downloadable' || summarizer.availability === 'downloading'"
            :value="summarizer.downloadProgress"
            class="mb-4"
            height="30"
          >
            <strong>
              Baixando o modelo:
              {{ Math.ceil(summarizer.downloadProgress) }}%
            </strong>
          </v-progress-linear>

          <v-alert
            v-if="summarizer.error"
            type="error"
          >
            {{ summarizer.error }}
          </v-alert>

          <v-skeleton-loader
            v-if="summarizing && !(summarizer.availability === 'downloadable' || summarizer.availability === 'downloading')"
            type="paragraph@3"
          ></v-skeleton-loader>

          <span v-html="markdownToHtml(summary)"></span>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import ChatList from "./components/ChatList.vue";
import ChatToolbar from "./components/ChatToolBar.vue";
import ChatEvents from "./components/ChatEvents.vue";
import ChatAnswerBar from "./components/ChatAnswerBar.vue";

export default {
  components: {
    ChatList,
    ChatToolbar,
    ChatEvents,
    ChatAnswerBar,
  },

  data() {
    return {
      showSessionsFromOtherServices: false,
      showSummary: false,
      summarizing: false,
      summary: '',
      summarizer: {
        availability: null,
        downloadProgress: 0,
        error: null,
        options: {
          length: 'short',
          type: 'tldr',
        },
      },
    };
  },

  async created() {
    await this.preLoad();
    this.checkServices();
    await this.getWaitingTreatment();

    if (this.$route.query.summarize !== undefined) {
      this.summarize();
    }

    window.addEventListener('keydown', (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'U') {
        this.summarize();
      }
    });
  },
  beforeDestroy() {
    this.clearConversationHistory()
  },
  computed: {
    ...mapGetters("rasaConversation", {
      currentConversation: "currentConversation",
      loadingSessionsFromOtherServices: "loadingSessionsFromOtherServices",
      sessionsFromOtherServices: "sessionsFromOtherServices",
    }),
    ...mapGetters("rasaServices", {
      currentService: "currentService",
    }),
    ...mapGetters("rasaSessions", {
      reloadingChatList: "reloadingChatList",
    }),
  },
  methods: {
    ...mapActions("rasaConversation", {
      loadSessionsFromOtherServices: "loadSessionsFromOtherServices",
      preLoad: "preLoad",
      clearConversationHistory: "clearConversationHistory"
    }),
    ...mapActions("rasaSessions", {
      getWaitingTreatment: "getWaitingTreatment",
    }),
    ...mapActions("rasaServices", {
      checkServices: "checkServices",
    }),

    markdownToHtml(text) {
      if (!text) {
        return '';
      }

      let html = text;

      html = html.replace(/\n/g, "<br>"); // Quebras de linha
      html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>'); // Negrito
      // html = html.replace(/\*(.*?)\*/g, '<em>$1</em>'); // Itálico
      html = html.replace(/~~(.*?)~~/g, '<del>$1</del>'); // Riscado
      html = html.replace(/^# (.*?)$/gm, '<h1>$1</h1>'); // Título 1
      html = html.replace(/^## (.*?)$/gm, '<h2>$1</h2>'); // Título 2
      html = html.replace(/^- (.*?)$/gm, '<li>$1</li>'); // Lista
      html = html.replace(/(<li>.*?<\/li>)/gs, '<ul>$1</ul>'); // Envolve itens de lista em <ul>
      html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>');

      return html;
    },

    async summarize() {
      console.log('Resumindo a conversa');

      if (this.summarizing) {
        return;
      }

      this.showSummary = true;
      this.summarizer.error = null;
      this.summarizing = true;
      this.summary = '';

      if (!('Summarizer' in self)) {
        console.log('Summarizer não disponível');
        this.summarizer.error = 'O Summarizer não está disponível neste navegador.';
        this.summarizing = false;
        return;
      }

      this.summarizer.availability = await self.Summarizer.availability();

      console.log('Disponibilidade do Summarizer:', this.summarizer.availability);

      if (this.summarizer.availability === 'unavailable') {
        this.summarizer.error = 'O Summarizer não está disponível neste navegador.';
        this.summarizing = false;
        return;
      }

      if (!navigator.userActivation.isActive) {
        console.log('Usuário não está ativo');
      }

      const options = {
        sharedContext: 'Essa é uma conversa entre um cliente e um atendente de suporte.',
        format: 'markdown',
        length: this.summarizer.options.length,
        type: this.summarizer.options.type,
        // expectedContextLanguages: ['pt-BR'],
        // expectedInputLanguages: ['pt-BR'],
        // outputLanguage: 'pt-BR',
        monitor: (m) => {
          m.addEventListener('downloadprogress', (e) => {
            this.summarizer.downloadProgress = e.loaded * 100 / e.total;
          });
        },
      };

      console.log('Criando o Summarizer');

      let summarizer = null;
      let stream = null;

      try {
        summarizer = await self.Summarizer.create(options);
      } catch (e) {
        console.error('Não foi possível criar o Summarizer:', e);
        this.summarizer.error = 'Não foi possível resumir: ' + e.message;
        this.summarizing = false;
        return;
      }

      console.log('Summarizer criado');

      this.summarizer.availability = 'available';

      if (!this.currentConversation || !this.currentConversation.messages) {
        this.summarizer.error = 'Nenhuma mensagem na conversa';
        this.summarizing = false;
        return;
      }

      let messages = [];

      for (let i = 0; i < this.currentConversation.messages.length; i++) {
        let message = this.currentConversation.messages[i];

        if (message.content_type === 'text' || message.content_type === 'audio') {
          let role = message.type === 'received' ? 'Cliente' : 'Atendente';
          let text = message.content.text || message.content.transcription;
          messages.push(`${role}: ${text}`);
        }
      }

      this.summarizing = true;

      try {
        stream = await summarizer.summarizeStreaming(messages.join('\n'));
      } catch (e) {
        console.error('Não foi possível iniciar o streaming do resumo:', e);
        this.summarizer.error = 'Não foi possível resumir: ' + e.message;
        this.summarizing = false;
        return;
      }

      console.log('Iniciando o streaming do resumo');

      for await (const chunk of stream) {
        this.summarizing = false;
        this.summary = (this.summary || '') + chunk;
      }

      console.log('Resumo criado');

      summarizer.destroy();

      // Por enquanto o Summarizer não suporta o português então usa o Translator para traduzir
      if ('Translator' in self) {
        console.log('Traduzindo o resumo para o português');

        try {
          const translator = await self.Translator.create({ sourceLanguage: 'en', targetLanguage: 'pt-BR' });
          this.summary = await translator.translate(this.summary);
          console.log('Resumo traduzido');
        } catch (e) {
          console.error('Não foi possível traduzir o resumo:', e);
        }
      }
    },
  },
  watch: {
    currentConversation(newValue, oldValue) {
      setTimeout(() => {
        if (newValue) {
          let customer = newValue.session?.customer;

          if (customer && customer.name) {
            document.title = `Atendimento - ${customer.name} - Dodo`;
          }

          this.loadSessionsFromOtherServices({
            sender: newValue?.session?.sender,
            serviceId: newValue?.session?.service_id,
          });
        }

        if (!this.$refs['chatEvents']) {
          return;
        }

        this.$refs['chatEvents'].scrollBottom();
      }, 200)
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  max-height: 100vh;
  .events-container {
    max-height: inherit;
    overflow: auto;
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 0px rgba(179, 179, 179, 0.712);
      background-color: transparent;
    }
    &::-webkit-scrollbar {
      width: 0px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: hsl(0, 0%, 43%);
    }
  }
}
.conversation-light {
  background-repeat: repeat;
  background-image: url("/img/wppBg.png");
}

.conversation-dark {
  background-repeat: repeat;
  background-image: url("/img/wppBgDark.png");
  .document {
    color: gray;
  }
  .expires-in {
    color: gray;
    font-size: 12px;
    line-height: 16px;
  }
}
.card-alert {
  background-color: red;
  font-size: 34px;
  // height: 100px;
}
</style>